import React, { useContext, useEffect, useRef, useState } from "react";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import "font-awesome/css/font-awesome.min.css";
import {
    Button,
    Input,
    Modal,
    Space,
    Table,
    Tag,
    Tooltip,
    Typography,
} from "antd";
import {
    DeleteOutlined,
    EditOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
const GalleryTable = () => {
    // search
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`جستجو`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{
                        marginBottom: 8,
                        display: "block",
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        style={{
                            width: 90,
                        }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => {
                            handleReset(clearFilters);
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }}
                        style={{
                            width: 90,
                        }}
                    >
                        حذف فیلتر
                    </Button>

                    <Button
                        type="link"
                        onClick={() => {
                            close();
                        }}
                    >
                        بستن
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            dataIndex === "tags"
                ? record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => (searchedColumn === dataIndex ? text : text),
    });
    // context
    const {
        forceUpdate,
        setSelectedGalleryId,
        setForceUpdate,
        selectedGalleryId,
        setGalleryColor,
        setGalleryIcon,
    } = useContext(context);
    // state
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteModalOpen, setDeleteIsModalOpen] = useState(false);

    // useEffect
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Gallery/`)
            .then((res) => {
                setLoading(false);
                setTableData(res.data.result);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [forceUpdate]);

    // columns
    const columns = [
        {
            title: "عنوان",
            dataIndex: "title",
            width: "10%",
            ...getColumnSearchProps("title"),
        },
        {
            title: "تگ",
            dataIndex: "tags",
            key: "tags",
            ...getColumnSearchProps("tags"),

            width: "10%",
            render: (_, { tags }) => (
                <>
                    {tags.map((t) => {
                        return <Tag key={t}>{t.toUpperCase()}</Tag>;
                    })}
                </>
            ),
        },
        {
            title: "توضیخات",
            dataIndex: "description",

            render: (_, { description }) => (
                <Tooltip title={description}>
                    <Typography.Paragraph style={{ cursor: "pointer" }}>
                        {description?.slice(0, 25)}
                        {description?.length > 25 ? "..." : null}
                    </Typography.Paragraph>
                </Tooltip>
            ),
        },
        {
            title: "آیکون",
            dataIndex: "icon",
            key: "icon",
            render: (icon, { color }) => {
                return icon ? (
                    <i
                        className={`fa ${icon
                            .split(/(?=[A-Z])/)
                            .map((word) => word.toLowerCase())
                            .join("-")}`}
                        style={{ fontSize: "30px", color: `${color}` }}
                    />
                ) : null;
            },
        },
        {
            title: "تعداد مدیا",
            dataIndex: "description",

            render: (_, { media }) => (
                <Typography.Paragraph>{media.length}</Typography.Paragraph>
            ),
        },
        {
            title: "عملیات",
            dataIndex: "button",
            key: "button",
            width: "10%",
            render: (text, record) => (
                <>
                    <Space style={{ width: "100%", direction: "ltr" }}>
                        <Button
                            onClick={() => {
                                setDeleteIsModalOpen(true);
                                setSelectedGalleryId(record._id);
                            }}
                            type="primary"
                            danger
                            shape="round"
                            icon={<DeleteOutlined />}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        />
                        <Tooltip title="ویرایش">
                            <Link to="/editGallery">
                                <Button
                                    onClick={() => {
                                        setSelectedGalleryId(record._id);
                                        setGalleryColor(record.color);
                                        setGalleryIcon(record.icon);
                                    }}
                                    type="primary"
                                    icon={<EditOutlined />}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                />
                            </Link>
                        </Tooltip>
                    </Space>
                </>
            ),
        },
    ];

    // functions
    const handleCancelModal = () => {
        setDeleteIsModalOpen(false);
    };
    const handleOkModal = () => {
        http.delete(`${config.parkopoloApi}/api/Gallery/${selectedGalleryId}`)
            .then(() => {
                setForceUpdate(11);
            })
            .catch((err) => {
                console.log(err);
                setForceUpdate(12);
            });
        setDeleteIsModalOpen(false);
        setForceUpdate(150);
    };
    return (
        <>
            <Table
                style={{ marginTop: "15px" }}
                size="small"
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                    showSizeChanger: false,
                }}
                bordered
                columns={columns}
                dataSource={tableData}
                scroll={{ x: true }}
                loading={loading}
                onRow={(record) => {
                    return {
                        onClick: () => setSelectedGalleryId(record._id),
                    };
                }}
            />
            <Modal
                title="حذف کامل"
                open={deleteModalOpen}
                onOk={handleOkModal}
                onCancel={handleCancelModal}
                okText="حذف"
            >
                <p>مطمئنی میخوای حذف کنی؟</p>
            </Modal>
        </>
    );
};

export default GalleryTable;
